<div class="row ">

  <div class="col-md-12">
    <div class="tile">
      <div class="mailbox-controls">
        <div class="animated-checkbox">
        </div>
        <div class="btn-group">
          <button class="btn btn-primary btn-sm" (click)="onAddOrEditDocument(null)" type="button">Add Doc<i
              class="fa fa-reply"></i></button>
        </div>
      </div>
      <div class="table-responsive mailbox-messages">
        <table class="table table-hover">
          <tbody>
            <tr *ngFor="let doc of docs; let i = index">
              <td>{{i+1}}.</td>
              <td><a href="{{doc.FilePath}}">{{doc.Name}} - <b>{{doc.ApplicationDocumentType}}</b></a></td>
              <td class="mail-subject"> {{doc.Description}}</td>
              <!-- <td><i class="fa fa-paperclip"></i></td> -->
              <td><a href="{{doc.FilePath}}"><i class="fa fa-eye"></i></a></td>
              <td><a href="javascript:void(0);" (click)="onAddOrEditDocument(doc)"><i class="fa fa-edit"></i></a></td>
              <td><a href="javascript:void(0);" (click)="onDelete(doc)"><i class="fa fa-trash-o text-danger"></i></a>
              </td>

            </tr>

          </tbody>
        </table>
      </div>

    </div>
  </div>
</div>